import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4" }
const _hoisted_4 = { class: "nav nav-pills customer-report-tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_7 = { class: "summary-chip" }
const _hoisted_8 = { class: "summary-chip chip-success" }
const _hoisted_9 = { class: "summary-chip chip-danger" }
const _hoisted_10 = { class: "py-4 text-center text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item",
              key: tab.key
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["nav-link", { active: _ctx.activeTab === tab.key }]),
                onClick: ($event: any) => (_ctx.$emit('tab-change', tab.key))
              }, _toDisplayString(tab.label), 11, _hoisted_5)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_total`)) + ": $" + _toDisplayString(_ctx.formatAmount(_ctx.summary.grandTotal)), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_paid`)) + ": $" + _toDisplayString(_ctx.formatAmount(_ctx.summary.paid)), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_due`)) + ": $" + _toDisplayString(_ctx.formatAmount(_ctx.summary.due)), 1)
        ])
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.items,
        "row-key": _ctx.rowKey,
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        scroll: { x: 980 },
        class: "text-nowrap align-middle customer-report-table",
        onChange: _ctx.handleChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.emptyText), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(record.created_at)), 1)
              ], 64))
            : (column && column.key === 'status')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["status-badge", _ctx.getStatusClass(record.status)])
                }, _toDisplayString(_ctx.formatLabel(record.status)), 3))
              : (column && column.key === 'invoice_total')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.invoice_total)), 1)
                  ], 64))
                : (column && column.key === 'paid')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.paid)), 1)
                    ], 64))
                  : (column && column.key === 'due')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.due)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "row-key", "loading", "pagination", "onChange"])
    ])
  ]))
}